import Tabs from "@/v2-backoffice-client/components/tabs"
import { useLicensePlansQuery } from "@/v2-backoffice-client/license/plan/license.plan.query"
import { LICENSING_VIEW_PLANS } from "@/v2-backoffice-client/license/license.constants"

// The Licensing page's Licenses tab trigger. Owns its own read of the licenses
// query — Apollo dedupes it against the board's — so the count stays live no
// matter which tab is open. Attention states (licenses that need setup) live
// in the board's own status pills, not up here.
function LicensePlanTabTrigger() {
  const { data, loading } = useLicensePlansQuery()
  const planCount = (data?.getLicensePlans ?? []).length

  return (
    <Tabs.Trigger
      value={LICENSING_VIEW_PLANS}
      iconSrc="tags"
      isLoading={loading}
      count={planCount}
    >
      Licenses
    </Tabs.Trigger>
  )
}

export default LicensePlanTabTrigger
